const MINUTE = 60_000;

// dates are 'YYYY-MM-DD' at the site, times are minutes after the site's local midnight
function parts(date: string): [number, number, number] {
  const [y = 1970, m = 1, d = 1] = date.split('-').map(Number);
  return [y, m - 1, d];
}

// minutes the zone is ahead of UTC at midday of that date (DST included)
export function utcOffset(date: string, timeZone: string): number {
  const noon = new Date(Date.UTC(...parts(date), 12));
  const local = new Intl.DateTimeFormat('en-GB', {
    timeZone,
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).format(noon);
  const [h = 12, m = 0] = local.split(':').map(Number);
  return (h - 12) * 60 + m;
}

export function instant(date: string, minutes: number, timeZone: string): Date {
  return new Date(Date.UTC(...parts(date)) + (minutes - utcOffset(date, timeZone)) * MINUTE);
}

export function localMinutes(at: Date, date: string, timeZone: string): number {
  return (at.getTime() - Date.UTC(...parts(date))) / MINUTE + utcOffset(date, timeZone);
}

export function today(timeZone: string): string {
  // en-CA formats as YYYY-MM-DD
  return new Intl.DateTimeFormat('en-CA', { timeZone }).format(new Date());
}

export function clockText(minutes: number): string {
  const m = Math.round(minutes);
  return `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`;
}
